import React, { PureComponent } from 'react';

import { HorizontalButtonPairView } from '../components/DRViewUtils';
import { getConfig } from '../utils/configUtils';
import { cancelColor, confirmBorderColor } from '../constants/Styles';

// ConfirmTaskCancelScreen is used for double-confirming task cancellation from queue view
export default class ConfirmTaskCancelScreen extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const buttonFontSize = 20;
    const buttonHeight = 72;
    const buttonWidth = '44%';
    const buttonSettings = [
      {
        phrase: 'GO BACK',
        fontColor: confirmBorderColor,
        fontSize: buttonFontSize,
        borderColor: confirmBorderColor,
        fillColor: '#ffffff',
        width: buttonWidth,
        height: buttonHeight,
        action: this.props.onClose,
      },
      {
        phrase: 'CANCEL TASK',
        fontColor: cancelColor,
        fontSize: buttonFontSize,
        borderColor: cancelColor,
        fillColor: '#ffffff',
        width: buttonWidth,
        height: buttonHeight,
        action: this.props.onConfirm,
      },
    ];
    let supportNumber = getConfig().site?.supportNumber || '';

    //get rid of confusing nested parens
    let m = /^\(([0-9]{3,3})\)/.exec(supportNumber);
    if (m) supportNumber = `${m[1]}-${supportNumber.slice(5).trim()}`;
    const phrase = `Cancel This Task?`;
    const text = `Moxi support ${
      supportNumber ? `(${supportNumber}) ` : ''
    }could help resolve an issue without canceling the task. Are you sure you want to cancel this task?`;

    return (
      <div style={{ flex: 1, display: 'flex', flexFlow: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ margin: 20, textAlign: 'center' }}>
          <div style={{ fontWeight: 700, fontSize: 35, alignSelf: 'center', marginBottom: 28 }}>{phrase}</div>
          <div style={{ fontWeight: 400, alignSelf: 'center', fontSize: '1.25rem' }}>{text}</div>
          <div style={{ marginTop: 40 }}>
            <HorizontalButtonPairView buttonSettings={buttonSettings} style={{ flex: 0.1 }} />
          </div>
        </div>
      </div>
    );
  }
}

ConfirmTaskCancelScreen.navigationOptions = {
  header: null,
};

// Note: This is needed because publishing to expo runs minify, which changes the class names. In particular, classes
//       can end up with the same name which breaks the screen transition logic.
ConfirmTaskCancelScreen.viewName = 'ConfirmTaskCancelScreen';
